import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import FloatingCTA from '../../components/feature/FloatingCTA';
import { blogPosts } from '../../mocks/blogData';

export default function BlogPage() {
  const [featured, ...rest] = blogPosts;

  return (
    <>
      <Header />
      <FloatingCTA />

      <section className="pt-32 pb-16 bg-brand-dark">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-flex items-center gap-2 text-brand-amber text-xs font-bold uppercase tracking-widest mb-5">
            <div className="h-px w-8 bg-brand-amber" />
            Our Blog
            <div className="h-px w-8 bg-brand-amber" />
          </div>
          <h1 className="font-serif text-5xl md:text-6xl font-bold text-white mb-5">
            Home Safety &amp; Cleaning Tips for Jacksonville Homeowners
          </h1>
          <p className="text-white/70 text-xl">Expert advice from Jacksonville's chimney, air duct, and dryer vent cleaning specialists.</p>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Featured post */}
          <div className="flex flex-col lg:flex-row gap-0 rounded-2xl overflow-hidden border border-stone-200 mb-14">
            <div className="lg:w-1/2 h-64 lg:h-auto">
              <img src={featured.image} alt={featured.title} className="w-full h-full object-cover object-top" />
            </div>
            <div className="lg:w-1/2 p-8 lg:p-12 flex flex-col justify-center">
              <div className="flex items-center gap-3 mb-4">
                <span className="bg-amber-100 text-brand-amber text-xs font-bold px-3 py-1.5 rounded-full">{featured.category}</span>
                <span className="text-brand-warm-gray text-xs">{featured.readTime}</span>
              </div>
              <h2 className="font-serif text-3xl font-bold text-brand-dark mb-4 leading-snug">{featured.title}</h2>
              <p className="text-brand-warm-gray text-base leading-relaxed mb-6">{featured.excerpt}</p>
              <div className="flex items-center justify-between">
                <div className="text-brand-warm-gray text-sm">{featured.date} · {featured.author}</div>
                <Link to="/blog" className="flex items-center gap-2 text-brand-amber font-semibold text-sm hover:underline cursor-pointer whitespace-nowrap">
                  Read More
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line" />
                  </div>
                </Link>
              </div>
            </div>
          </div>

          {/* Post grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7">
            {rest.map((post) => (
              <div key={post.id} className="rounded-xl overflow-hidden border border-stone-200 hover:border-brand-amber/40 transition-all">
                <div className="h-48 overflow-hidden">
                  <img src={post.image} alt={post.title} className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-500" />
                </div>
                <div className="p-5">
                  <div className="flex items-center gap-2 mb-3">
                    <span className="bg-amber-50 text-brand-amber text-xs font-semibold px-2.5 py-1 rounded-full">{post.category}</span>
                    <span className="text-brand-warm-gray text-xs">{post.readTime}</span>
                  </div>
                  <h3 className="font-serif text-lg font-bold text-brand-dark mb-2 leading-snug">{post.title}</h3>
                  <p className="text-brand-warm-gray text-sm leading-relaxed mb-4 line-clamp-3">{post.excerpt}</p>
                  <div className="flex items-center justify-between">
                    <span className="text-brand-warm-gray text-xs">{post.date}</span>
                    <Link to="/blog" className="flex items-center gap-1 text-brand-amber font-semibold text-sm hover:underline cursor-pointer whitespace-nowrap">
                      Read
                      <div className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-arrow-right-line text-xs" />
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Newsletter / CTA */}
          <div className="mt-14 bg-brand-muted rounded-2xl border border-stone-200 p-10 text-center">
            <h2 className="font-serif text-3xl font-bold text-brand-dark mb-3">Ready to Book a Service?</h2>
            <p className="text-brand-warm-gray text-lg mb-7 max-w-xl mx-auto">Stop reading about it — let our certified Jacksonville technicians take care of it for you.</p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/contact" className="bg-brand-amber hover:bg-brand-amber-dark text-white font-bold py-3.5 px-10 rounded-lg text-base cursor-pointer whitespace-nowrap transition-all">Book Service</Link>
              <Link to="/services" className="border border-stone-300 hover:border-brand-amber text-brand-dark hover:text-brand-amber font-semibold py-3.5 px-8 rounded-lg text-base cursor-pointer whitespace-nowrap transition-all">View Services</Link>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}
